import { useEffect, useState } from "react";

// current date, refreshed every `refreshMs` and when the page becomes visible again: timers are
// frozen while a device sleeps, `now` would be stale for up to `refreshMs` after it wakes up
export function useNow(refreshMs: number): Date {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const refresh = () => setNow(new Date());
    const refreshIfVisible = () => {
      if (document.visibilityState === "visible") {
        refresh();
      }
    };
    const interval = setInterval(refresh, refreshMs);
    document.addEventListener("visibilitychange", refreshIfVisible);
    window.addEventListener("pageshow", refresh);
    return () => {
      clearInterval(interval);
      document.removeEventListener("visibilitychange", refreshIfVisible);
      window.removeEventListener("pageshow", refresh);
    };
  }, [refreshMs]);

  return now;
}
